import ErrorMessage from 'components/common/ErrorMessage';
import { AuthLayout } from 'layouts/AuthLayout';
import React, { memo, useCallback, useState } from 'react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { resetPassword } from 'slices/userSlice';
import { userSelector } from 'slices/userSlice';
import { setError } from 'slices/userSlice';

const Footer = memo(() => (
    <div className='center_wrapper'>
        <p className="para3">Don’t have Interpreter Account? <Link to="/register">Let’s Create One!</Link></p>
    </div>
))

function ResetPassword() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { error } = useSelector(userSelector)
    // The reset email links to /reset-password?token=...&email=... — these
    // are required by the backend and must be sent with the new password.
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') || '';
    const email = searchParams.get('email') || '';

    const [formValues, setFormValues] = useState({
        password: '',
        password_confirmation: '',
    });
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleChange = useCallback((e) => {
        setFormValues({ ...formValues, [e.target.name]: e.target.value });
    }, [formValues])

    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
    className:"successToast",
})
            navigate('/login');
        }
        else {
             toast.error(message,
        {
          className:"errorToast",
        }
      );
        }
    };
    const resetAllErrors = () => {
        dispatch(setError({}))
    }
    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        if (!token || !email) {
            toast.error('This reset link is invalid or has expired. Please request a new one.', { className: 'errorToast' });
            return;
        }
        resetAllErrors()
        dispatch(resetPassword({ ...formValues, token, email }, submitCallback))
    }, [formValues, token, email]);

    
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    
    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };



    return (
        <AuthLayout
            heading="Set New Password"
            title=""
            footer={<Footer />}
        >
            <form className='auth_form' action='' onSubmit={handleSubmit}>
                <div className="form-group">
                    <div className="form-group">
                        <div className="row-input">
                            <img src="/images/lock.png" alt="" />
                            <input
                                type={showPassword ? "text" : "password"}
                                name="password" id="password"
                                autoComplete="off"
                                onChange={handleChange}
                                placeholder="Enter a new password"
                                required
                            />
                            <img
                                src={showPassword ? "/images/eye-close.png" : "/images/eye.png"}
                                alt=""
                                onClick={togglePasswordVisibility}
                                style={{ cursor: 'pointer' }}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="row-input">
                            <img src="/images/lock.png" alt="" />
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                name="password_confirmation"
                                id="password_confirmation"
                                autoComplete="off"
                                placeholder="Enter Confirm password"
                                onChange={handleChange}
                                required
                            />
                            <img
                                src={showConfirmPassword ? "/images/eye-close.png" : "/images/eye.png"}
                                alt=""
                                onClick={toggleConfirmPasswordVisibility}
                                style={{ cursor: 'pointer' }}
                            />
                        </div>
                    </div>
                    {/* {confirmPasswordError && <div className='error-message'>{confirmPasswordError}</div>} */}
                    {
                        error?.errors?.password?.map((error) => (
                            <ErrorMessage text={error} />
                        ))
                    }
                </div>
                <button className="btn_auth">Reset Password</button>
            </form>
        </AuthLayout>
    )

}

export default ResetPassword;
